module.exports = __webpack_public_path__ + "img/40.76e27854.jpg";